import { render, staticRenderFns } from "./VideosNew.vue?vue&type=template&id=12591df9&"
import script from "./VideosNew.vue?vue&type=script&lang=js&"
export * from "./VideosNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports